import { Capacitor, registerPlugin } from "@capacitor/core";

// Bridge to the app-local EngineHaptics CoreHaptics plugin (iOS, build ≥18).
// Times in seconds; values 0..1. `intensity`/`sharpness` are parameter curves
// shaping a continuous rumble bed; `transients` are engine-firing pops.
type EngineHapticsPlugin = {
  play(o: {
    duration: number;
    intensity: number[][];
    sharpness: number[][];
    transients: number[][];
  }): Promise<void>;
  stop(): Promise<void>;
};

// registerPlugin is OTA-safe: this bundle also ships to binaries that don't
// carry the native class (≤ build 17), where isPluginAvailable() is false and
// callers must fall back. Never call play() without checking availability.
export const EngineHaptics = registerPlugin<EngineHapticsPlugin>("EngineHaptics");
export const engineHapticsAvailable = () =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable("EngineHaptics");
